<script setup lang="ts">
import { computed } from 'vue';
import {
    ChevronDown,
    CircleUser,
    Cog,
    FolderHeart,
    LogOut,
} from 'lucide-vue-next';
import { Avatar, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import useApp from '@/composables/useApp.ts';
import type { Consortium } from '@/types';

const { user, site } = useApp();
const consortium = computed<Consortium>(() => user.consortiums.at(0));
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button
                variant="ghost"
                size="lg"
                class="!px-3"
            >
                <Avatar v-if="consortium">
                    <AvatarImage
                        :src="consortium.logo"
                        :alt="consortium.title"
                        class="object-contain object-center"
                    />
                </Avatar>
                <span class="-mr-1 hidden lg:inline">{{ user.name }}</span>
                <ChevronDown />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
            class="w-56"
            align="end"
        >
            <DropdownMenuLabel class="p-0 font-normal">
                <div class="p-small flex items-center gap-2 px-1 py-1.5">
                    <div class="grid flex-1 text-left leading-tight">
                        <span class="truncate font-semibold">{{
                            user.name
                        }}</span>
                        <span class="text-muted-foreground truncate text-xs">
                            {{ user.email }}
                        </span>
                    </div>
                </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
                <DropdownMenuItem as-child>
                    <a :href="site.url + 'profil'">
                        <CircleUser />
                        Mein Profil
                    </a>
                </DropdownMenuItem>
                <DropdownMenuItem as-child>
                    <a :href="site.url + 'merkliste'">
                        <FolderHeart />
                        Favoriten
                    </a>
                </DropdownMenuItem>
                <DropdownMenuItem as-child>
                    <a :href="site.url + 'einstellungen'">
                        <Cog />
                        Einstellungen
                    </a>
                </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem as-child>
                <a :href="site.logoutUrl">
                    <LogOut />
                    Logout
                </a>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
